import ctl from '@netlify/classnames-template-literals'
import { motion, useTime, useTransform } from 'motion/react'

export function MagicSwirl() {
	const time = useTime()
	const rotate = useTransform(() => `${(time.get() / 2)}px`)
	const rotate2 = useTransform(() => `calc(50% + ${(time.get() / 2)}px)`)

	const inputInnerClassName = ctl(`
    absolute inset-[-2px] rounded-[10px]
    pointer-events-none border-[2px] border-transparent 
    [mask-clip:padding-box,border-box] [mask-composite:intersect] 
    [mask-image:linear-gradient(transparent,transparent),linear-gradient(#000,#000)]
`)

	const swirlClassName = ctl(`
    [offset-path:rect(0px_auto_auto_0px_round_20px)] 
    w-[100px] h-[30px] 
    bg-gradient-to-l from-fuchsia-500/20 via-brand-500/60 to-fuchsia-500/0
    blur-lg
`)

	return (
		<motion.div
			initial={{
				opacity: 0,
			}}
			animate={{
				opacity: 1,
			}}
			transition={{
				duration: 0.3,
			}}
			className={inputInnerClassName}
		>
			<motion.div className={swirlClassName} style={{ offsetDistance: rotate }} />
			<motion.div className={swirlClassName} style={{ offsetDistance: rotate2 }} />
		</motion.div>
	)
}
